// The trip as the full build reads it when it has an agenda (backend agents/agenda.py). Two views of one trip
// (owner, 2026-11-04): "Your trip at a glance" says WHAT is in it — the selection, the one truth for places —
// and the calendar says WHEN — each place on its day.
//   pins  — each place on the day they put it, in that part of the day, and the table they chose for a meal;
//   picks — the selection as it stands now (what they took out on either view is no longer in it), plus what is on
//           the days without being in the selection: a place of ours that filled an hour, the table they chose.

const CATEGORY_BACK = { culture: "CULTURE", food: "FOODIE", nightlife: "NIGHTLIFE", special: "SPECIAL", popular: "POPULAR", hidden_gem: "HIDDEN" };
export const placeKey = (p) => String((p && (p.pick || p.name)) || "").trim().toLowerCase();

export function agendaChoice(days, selectionPicks, listed = null) {
  // a place of the glance it no longer holds was taken out there: it leaves the days too, even unseen on the calendar
  const chosen = new Set((selectionPicks || []).map((p) => placeKey(p)));
  const kept = (p) => !(listed && listed.has(placeKey(p)) && !chosen.has(placeKey(p)));
  const pins = {
    days: days.map((d) => ({
      date: d.date,
      places: d.parts.flatMap((part) => [
        ...(part.places || []).filter(kept).map((p) => ({ name: p.name, part: part.key })),
        ...(part.chosen ? [{ name: part.chosen.name, part: part.key }] : []),
      ]),
    })),
  };
  const picks = [...(selectionPicks || [])];
  const known = new Set(picks.map((p) => placeKey(p)));
  for (const d of days) {
    for (const part of d.parts) {
      for (const p of part.places || []) {
        if (known.has(placeKey(p)) || !kept(p)) continue;
        known.add(placeKey(p));
        picks.push({
          name: p.name, city: p.city || "", neighborhood: p.area || "",
          category: CATEGORY_BACK[p.category] || "", duration_h: (p.minutes || 90) / 60,
          from_catalog: true, is_sacred: false, meal_role: null, why: "", description: "", tip: "",
          user_added: !!p.added,
        });
      }
      const table = part.chosen;
      if (table && !known.has(placeKey(table))) {
        known.add(placeKey(table));
        picks.push({
          name: table.name, city: table.city || d.city || "", neighborhood: table.area || "", category: "FOODIE",
          duration_h: (table.minutes || 60) / 60, from_catalog: true, is_sacred: false, meal_role: part.key,
          why: "", description: "", tip: "", user_added: true,
        });
      }
    }
  }
  return { pins, picks };
}

// the places of the selection the agenda does not hold yet (chosen on the glance after the agenda was laid out, or
// that did not fit): the calendar shows them as "to place"
export function toPlaceOf(days, tray, extractedPlaces, selectedPlaces, previewPicks) {
  const selected = new Set((selectedPlaces || []).map((n) => String(n).toLowerCase()));
  const held = new Set();
  (days || []).forEach((d) => d.parts.forEach((part) => {
    (part.places || []).forEach((p) => held.add(placeKey(p)));
    (part.options || []).forEach((p) => held.add(placeKey(p)));
    if (part.chosen) held.add(placeKey(part.chosen));
  }));
  (tray || []).forEach((p) => held.add(placeKey(p)));
  const meals = new Set((previewPicks || []).filter((p) => p && p.meal_role).map((p) => placeKey(p)));
  const seen = new Set();
  return (extractedPlaces || []).filter((p) => {
    const k = placeKey(p);
    if (!k || seen.has(k) || !selected.has(k) || held.has(k) || meals.has(k)) return false;
    seen.add(k);
    return true;
  }).map((p) => ({
    id: `to-place-${placeKey(p)}`, name: p.name, pick: p.name, city: p.city || "", area: p.neighborhood || "",
    category: String(p.category || "").toLowerCase().replace("foodie", "food").replace("hidden", "hidden_gem"),
    minutes: typeof p.duration === "number" ? Math.round(p.duration * 60) : 90, lat: p.lat, lng: p.lng, image: p.image || "",
  }));
}
